/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolPencilIcon32Regular = forwardRef('ToolPencilIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.63 4.885a3 3 0 0 0-4.242 0L4.878 21.394A3 3 0 0 0 4 23.515V26.5A1.5 1.5 0 0 0 5.5 28h2.985a3 3 0 0 0 2.122-.878l16.509-16.51a3 3 0 0 0 0-4.242l-1.485-1.485Zm-2.828 1.414a1 1 0 0 1 1.415 0l1.485 1.485a1 1 0 0 1 0 1.414l-2.396 2.396-2.9-2.9L22.803 6.3Zm-3.81 3.81-12.7 12.7a1 1 0 0 0-.292.706V26h2.485a1 1 0 0 0 .707-.292l12.7-12.7-2.9-2.9Z" })));
});
